const PERIOD = {
    WEEKLY: "WEEKLY",
    BIWEEKLY: "BIWEEKLY",
    MONTHLY: "MONTHLY"
};

export const PERIOD_DICTIONARY = {
    [PERIOD.WEEKLY]: "Weekly",
    [PERIOD.BIWEEKLY]: "BiWeekly",
    [PERIOD.MONTHLY]: "Monthly"
};
